import { getUrlParamsFetch, handleAxiosError, ROUTER_PATHS } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import {
  urlBackend,
} from '@/shared/constants/networking.constants';
import {
  AlertSeverityEnum,
  IDataPreventa,
  IDataPreventaParams,
  IFormPreventa,
  IPreventa,
  PoligonoPreventa,
  UseMutationsParams,
  Zone,
} from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

const { get, post, put } = erpApi();


export const useGetPreventas = (params?: IDataPreventaParams, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['preventas', ...Object.values(params || {})],
    queryFn: async () => {
      return await getPreventaByFilter(params);
    },
    retry: false,
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const getPreventaByFilter = async (params?: IDataPreventaParams) => {
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<IPreventa>(
    `${urlBackend}api/v1/preventa/?${queryParams}`,
    true
  );

  return resp;
};

export const useCreatePreventa = ({
  navigate,
  returnUrl = ROUTER_PATHS.ventas.preventasNav
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  const setConfirmDialog = useUiStore.getState().setConfirmDialog;
  const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;
  const setAlert = useUiStore.getState().setAlert

  return useMutation({
    mutationFn: createPreventa,
    onSuccess: async (data, form) => {
      queryClient.invalidateQueries({ queryKey: ['preventas'] });

      if (data.code == 200) {
        setConfirmDialogIsOpen(true);
        setConfirmDialog({
          isOpen: true,
          title: '¡Creado con éxito!',
          subtitle: form.no_cobrar
            ? '¡Preventa creada exitosamente! Incluye una solicitud para liberación del valor de instalación. Pronto recibirás una respuesta.'
            : form.pre_requiere_contrato_fisico
              ? '¡Preventa creada exitosamente! Incluye una solicitud para contrato físico. Pronto recibirás una respuesta.'
              : '¡Preventa creada exitosamente! Ahora solo falta crear un preagendamiento una vez que el cliente firme el contrato',
          onClose() {
            setConfirmDialogIsOpen(false);
            navigate && navigate(returnUrl)
          },
          onConfirm() {
            setConfirmDialogIsOpen(false);
            // if (form.no_cobrar || form.pre_requiere_contrato_fisico)
            return navigate && navigate(returnUrl)

            // navigate && navigate(`${ROUTER_PATHS.ventas.preagendamientoCrearNav}${data.data.id_preventa}`)
          },
          cancelTextBtn: 'Cerrar'
        });
      }
    },
    onError: error => {
      if (isAxiosError(error)) {
        handleAxiosError(error)
      }
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    }
  });
};

export const createPreventa = async (data: IFormPreventa) => {
  const resp = await post<IDataPreventa>(`${urlBackend}api/v1/preventa/`, data, true);
  return resp;
};

export const useGetPreventaById = (id: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['preventas', id],
    queryFn: async () => {
      return await getPreventaById(id);
    },
    enabled
  });
};

export const getPreventaById = async (id: string) => {
  const resp = await get<IDataPreventa>(`${urlBackend}api/v1/preventa/${id}/`, true);
  return resp.data;
};


export const useUpdatePreventa = ({
  navigate,

  enableAlert = true,
  queryKey = 'preventas',

  returnUrl,

  enableSuccessAlert = true,
  customSuccessMessage,

}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  //const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({

    mutationFn: async ({ id, data }: { id: string; data: IDataPreventaParams }) =>
      putPreventaById(id, data),
    onSuccess: (data) => {

      queryClient.invalidateQueries({ queryKey: [queryKey, data.data.id_preventa] });
      queryClient.invalidateQueries({ queryKey: [queryKey] });

      navigate && returnUrl && navigate(returnUrl);

      enableAlert && enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Datos actualizados correctamente',
          AlertSeverityEnum.success
        );

    },
    onSettled: () => {
      //setIsGlobalLoading(false);
    },

  });
};

export const usePoligonoFetch = ({ }: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ data }: { data: PoligonoPreventa }) => {
      return postPoligono(data);
    },
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ['poligonos'] });

      console.log(response);
      /* if (response.data)
        return setAlert(true, response.message, response.status);
      return setAlert(true, 'Lo sentimos, las coordenadas están fuera de la zona ingresada.', AlertSeverityEnum.error) */

    },
    onError: (error) => {
      handleAxiosError(error)
    }
  })
}

///* obtener localidad
export const postPoligono = async (data: PoligonoPreventa) => {
  const resp = await post<Zone>(`${urlBackend}api/v1/obtener-zona/`, data, true);
  return resp;
}


export const putPreventaById = async (id: string, data: IDataPreventaParams) => {
  //const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;
  //setIsGlobalLoading(true);

  const resp = await put<IDataPreventa>(`${urlBackend}api/v1/preventa/${id}/`, data, true);
  return resp;
};

export const postContrato = async (idPreventa: number) => {
  const resp = await post<IDataPreventa>(
    `${urlBackend}api/v1/contrato-internet/`,
    {
      id_preventa: idPreventa,
    },
    false
  );
  return resp;
};

export const useGetPreventaByIdPublico = (id: number) => {
  return useQuery({
    queryKey: ['preventas-publico', id],
    queryFn: async () => {
      return await getPreventaByIdPublico(id);
    },
  });
};

export const getPreventaByIdPublico = async (id: number) => {
  const resp = await get<IDataPreventa>(
    `${urlBackend}api/v1/get-preventa-u/${id}/`,
    false
  );
  return resp.data;
};

interface CalcularValorInstalacionParams {
  id_prospecto_corporativo?: string;
  id_prospecto?: string;
  score: number;
  segmentacion: string;
  forma_pago: string;
  es_pyme?: boolean
}

export interface ICalcularData {
  valor_instalacion: number;
  iva: number;
}

export const useFetchCalcularValorInstalacion = ({
  enableSuccessAlert
}: UseMutationsParams) => {
  const queryClient = useQueryClient();

  const setAlert = useUiStore.getState().setAlert;

  return useMutation({
    mutationFn: async (params: CalcularValorInstalacionParams) => {
      queryClient.invalidateQueries({ queryKey: ['calcular-valor-instalacion'] });

      return postCalcularValorInstalacion(params);
    },
    onSuccess: e => {
      enableSuccessAlert && setAlert(true, e.message, e.status)
    },
    onError: e => {
      handleAxiosError(e);
    }
  });
}
export const postCalcularValorInstalacion = async (params?: CalcularValorInstalacionParams) => {
  const resp = await post<ICalcularData>(
    `${urlBackend}api/v1/calcular-valor-instalacion/`,
    params,
    true,
  );
  return resp;

}

export const getPreventaByReferidoEmpleado = async (params?: IDataPreventaParams) => {
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<{ task_id: string }>(
    `${urlBackend}api/v1/preventa/referidos-empleados/excel-async/?${queryParams}`,
    true
  );

  return resp;
};